import { MRT_ColumnDef } from "material-react-table";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { IFilteringViewModel } from "../../_common/interface/table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { emailLogService } from "../../_services/emailLog.service";
import { PrimaryButton } from "../button/primary.button";
import { CommonTable } from "../table/common.table";
import { toastr } from "../toastr/toastr";
import { EmailLogManageDrawer } from "./emailLog-manageDrawer";
import { useParams } from "react-router-dom";
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import React from "react";
import { usersService } from "../../_services/users.service";
import { accountService } from "../../_services/accounts.service";


export function EmailLogList() {

    const [data, setData] = useState({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [dialog, setDialog] = useState<any | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel | null>(null);
    const [search, setSearch] = useState<any>({});
    const { formId } = useParams<{ formId: string }>();

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'subject',
                header: 'Subject',
            },
            {
                accessorKey: 'comment',
                header: 'Comment',
            },
        ],
        [],
    );

    useEffect(() => {
        if (filter != null)
            fetchData();
    }, [filter]);

    function fetchData() {

        return emailLogService.getAll({ ...filter, ...search, formId: formId })
            .then(
                json => {
                    setData({ ...json, _value: (json.value + "%"), startDate: moment(json.startDate).format('DD/MM/YYYY'), expiryDate: moment(json.expiryDate).format('DD/MM/YYYY') });
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function onDelete(id: number) {
        setLoading(true);
        return emailLogService
            .disable(id)
            .then(
                () => {
                    fetchData();
                    toastr.success("EmailLog Type disabled successfully");
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (

        <Paper>

            <CommonTable
                tableHeader="Form Email Log"
                columns={columns}
                data={data}
                onView={(item) => { setDialog(item) }}
                filter={filter}
                height={200}
                setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                isLoading={isLoading}
            />
            <PrimaryButton icon={"send"} isLoading={isLoading} variant="primary" type="button" onClick={() => { setSelectedId(0) }}>Create an Email</PrimaryButton>
            {(accountService.isAdmin === true) &&
                <Dialog
                    onClose={(item) => { setDialog(null) }}
                    aria-labelledby="customized-dialog-title"
                    open={!!dialog}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        {dialog?.subject}
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={(item) => { setDialog(null) }}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <Icon>close</Icon>
                    </IconButton>
                    <DialogContent dividers>
                        <Typography gutterBottom>
                            <div dangerouslySetInnerHTML={{ __html: dialog?.body }} />
                        </Typography>
                    </DialogContent>

                </Dialog>
            }
            <EmailLogManageDrawer
                isOpen={selectedId != null}
                itemId={selectedId}
                onSave={() => { setSelectedId(null); fetchData(); }}
                onClose={() => { setSelectedId(null); fetchData(); }}
            />

        </Paper>


    );

}
